import styled from 'styled-components';

import { Button, FocusRingVariants } from '@calm-web/design-system';

export const SubmitButton = styled(Button).attrs({
	focusRingVariant: FocusRingVariants.Dark,
})`
	margin-top: 12px;
`;
